const CONFIG_VAR = '___APP_CONFIG___';

function get(key) {
	if (!window[CONFIG_VAR]) {
		throw "Missing app configuration file config-env.json";
	}
	
	return window[CONFIG_VAR][key];
}

export default {
	get
}